export const TAG = 'SessionTimeout';

export const DEFAULT_TIMEOUT = 60; // in minutes

export const DEFAULT_SESSION_POPUP_INTERVAL = 60; // in seconds
